import { Component } from '@angular/core';
import { MedrecordInputNgControlComponentBase } from '../../base/medrecord-input-ng-control-component-base.component';

@Component({
  selector: 'medrecord-checkbox',
  templateUrl: './medrecord-checkbox.component.html',
  styleUrls: ['./medrecord-checkbox.component.scss']
})
export class MedrecordCheckboxComponent extends MedrecordInputNgControlComponentBase {
}